export { default as withSizes } from './withSizes'
